import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";

export const FeedbackPopup = ({ message }) => {
  return (
    <div className="saved">
      <div className="icon__container">
        <Icon id="check-solid" />
      </div>

      <p>{message || i18n.t("feedback.changesSaved")}</p>
    </div>
  );
};

FeedbackPopup.propTypes = {
  message: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Layout/FeedbackPopup.js